import { FC } from 'react';

import { ProviderPlanId } from '__generated__/GQL';
import SunshineTag, { SunshineTagProps } from 'components/_core/SunshineTag';

interface Props {
  plan: ProviderPlanId;
}

const PLAN_NAME_MAP = {
  [ProviderPlanId.Basic]: 'Shine Basic',
  [ProviderPlanId.Business]: 'Shine Business',
  [ProviderPlanId.Plus]: 'Shine Plus',
  [ProviderPlanId.Pro]: 'Shine Pro',
  [ProviderPlanId.MoralPersonBasic]: 'Shine Basic',
  [ProviderPlanId.MoralPersonPremium]: 'Shine Plus',
  [ProviderPlanId.MoralPersonBusiness]: 'Shine Pro',
  [ProviderPlanId.PhysicalPersonBasic]: 'Shine Basic',
  [ProviderPlanId.PhysicalPersonPremium]: 'Shine Plus',
} as const;

export const PlanTag: FC<Props> = ({ plan }) => {
  const planName = PLAN_NAME_MAP[plan];

  const colorScheme = {
    [ProviderPlanId.Basic]: 'grey',
    [ProviderPlanId.Business]: 'red',
    [ProviderPlanId.Plus]: 'blue',
    [ProviderPlanId.Pro]: 'yellow',
    [ProviderPlanId.MoralPersonBasic]: 'grey',
    [ProviderPlanId.MoralPersonPremium]: 'blue',
    [ProviderPlanId.MoralPersonBusiness]: 'yellow',
    [ProviderPlanId.PhysicalPersonBasic]: 'grey',
    [ProviderPlanId.PhysicalPersonPremium]: 'blue',
  } satisfies Record<ProviderPlanId, SunshineTagProps['colorScheme']>;

  return (
    <SunshineTag
      colorScheme={colorScheme[plan]}
      marginTop="space-8"
      noOfLines={1}
      size="sm"
    >
      {planName}
    </SunshineTag>
  );
};
